import HrnModal from "./HrnModal";

export default HrnModal;
